import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//- Get All
export const GetAllPublished = createAsyncThunk(
  "homepage/publishedbook/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.HomePage.PublishedBook}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "publishedbook",
  initialState: {
    all_publishedbook: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      //GET ALL
      .addCase(GetAllPublished.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllPublished.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_publishedbook = action.payload?.data || [];
      })
      .addCase(GetAllPublished.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
